import { AlertBlock, Typography, PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { RcFile } from 'antd/lib/upload';
import { useTranslation } from 'react-i18next';

import { formatByMask } from 'src/common/helpers/common.helpers';
import { timeFormat } from 'src/common/helpers/date.helpers';
import { useUpdateEmployeeAvatarById } from 'src/hooks/employees/update-employee-avatar-by-id.hook';
import { ChangeAvatarInput } from 'src/pages/employee/sub-pages/employee-details/components/change-avatar-input';

import { InfoBlock, InfoContainer, WorkingHoursBlock } from './employee-details-info.styles';

const EmployeeDetailsInfo = ({ data }: { data: any }) => {
  const { startFrom, startFromString, breakTime, ...workingDays } = data.workingDays;
  const { t } = useTranslation(['employee', 'common']);
  const updateEmployeeAvatar = useUpdateEmployeeAvatarById();

  const uploadAvatar = (avatar?: RcFile) =>
    updateEmployeeAvatar({ variables: { employeeId: data._id, avatar } });

  return (
    <InfoContainer>
      <div>
        <ChangeAvatarInput data={data} onChange={uploadAvatar} />
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.fullName')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {data.firstName} {data.lastName}
          </Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('employee:labels.nickname')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{data.nickname}</Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.phoneNumber')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {formatByMask(data.phoneNumber, '+## ### ### #######')}
          </Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.email')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {data.email || '-'}
          </Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.gantt')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {data.gantt.name || '-'}
          </Typography>
        </InfoBlock>
      </div>
      <WorkingHoursBlock>
        <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employee:labels.workingHours')}
        </Typography>
        {startFromString && (
          <AlertBlock
            title={t('employee:labels.note')}
            description={t('employee:labels.noteDescription', { date: startFromString })}
          />
        )}
        {workingDays &&
          Object.entries(workingDays).map(
            ([key, value]: any) =>
              value && (
                <InfoBlock key={key}>
                  <Typography weight="bold">{t(`common:days.${key}`)}:</Typography>
                  <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                    {timeFormat(value.from)}-{timeFormat(value.to)}
                  </Typography>
                </InfoBlock>
              )
          )}
        <InfoBlock>
          <Typography weight="bold">{t('employee:labels.breakTime')}:</Typography>
          <Typography
            fontColor={PLATFORM_THEME_COLORS.primary.grey}
          >{`${breakTime} hr`}</Typography>
        </InfoBlock>
      </WorkingHoursBlock>
    </InfoContainer>
  );
};

export default EmployeeDetailsInfo;
